<template>
  <div class="contact-page">
    <content-page type="contact" title="联系我们" />
  </div>
</template>

<script>
import ContentPage from '../components/ContentPage.vue';

export default {
  name: 'ContactPage',
  components: {
    ContentPage
  }
}
</script>

<style scoped>
.contact-page {
  min-height: 100vh;
}
</style> 